export const countArticleCharacters = (content: string) => {
  const withoutImages = content.replace(/<img[^>]*>/gi, '');
  const withoutHtml = withoutImages.replace(/<[^>]*>/g, '');
  const matched = withoutHtml.match(/[A-Za-z0-9\u4E00-\u9FFF]/g);
  return matched ? matched.length : 0;
};
